import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import React from "react";
import { observer } from "mobx-react";
import {
	SelectedSportCheckBox,
} from "../category-items";

import { CategoryItems } from ".";

export const ExpandedTopTournamentMenu = observer(
	function ExpandedTopTournamentMenu(props: {
		store: {
			isEmpty: boolean;
			isLoading: boolean;
			toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
			selectedSport: PrematchOfferMenuStore["selectedSport"];
			menu: PrematchOfferMenuStore["menu"];
			type: "PrematchOfferMenuStore" | "LiveOfferMenuStore";
		};
	}) {
		if (props.store.selectedSport != null) {
			return (
				<>
					<SelectedSportCheckBox
						sport={props.store.selectedSport}
						store={props.store}
					/>
					<CategoryItems
						sport={props.store.selectedSport}
						store={props.store}
					/>
				</>
			);
		}
		return null;
	}
);
